import { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderMaster from '../components/HeaderMaster';
import SideBarMaster from '../components/SideBarMaster';
import FooterNavigationMaster from '../components/FooterNavigationMaster';
import styles from './EstabelecimentosMaster.module.css';
import { MdStore, MdSearch, MdToggleOn, MdToggleOff, MdLocationOn, MdSettings } from "react-icons/md";
import { EstabelecimentosContext } from '../../../shared/contexts/EstabelecimentosContext';
import axios from 'axios';

function EstabelecimentosMaster() {
    const navigate = useNavigate();
    const { todosEstabelecimentos, loading, fetchTodosEstabelecimentos } = useContext(EstabelecimentosContext);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterStatus, setFilterStatus] = useState('todos');

    // Buscar estabelecimentos quando a página montar
    useEffect(() => {
        fetchTodosEstabelecimentos();
    }, []);

    const toggleStatus = async (id, statusAtual) => {
        try {
            const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
            const token = localStorage.getItem('token');

            await axios.patch(
                `${API_URL}/master/estabelecimentos/${id}/status`,
                { ativo: !statusAtual },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            fetchTodosEstabelecimentos();
        } catch (error) {
            console.error("Erro ao alterar status:", error);
            alert("Erro ao alterar status do estabelecimento.");
        }
    };

    const filteredEstabelecimentos = todosEstabelecimentos.filter(est => {
        const matchSearch =
            est.nome_lanchonete.toLowerCase().includes(searchTerm.toLowerCase()) ||
            est.nome_universidade?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            est.nome_admin?.toLowerCase().includes(searchTerm.toLowerCase());

        const matchStatus =
            filterStatus === 'todos' ||
            (filterStatus === 'ativo' && est.ativo) ||
            (filterStatus === 'inativo' && !est.ativo);

        return matchSearch && matchStatus;
    });

    // Debug temporário
    console.log('🔍 DEBUG EstabelecimentosMaster:');
    console.log('Total estabelecimentos:', todosEstabelecimentos.length);
    console.log('Filtrados:', filteredEstabelecimentos.length);
    console.log('Loading:', loading);
    console.log('Dados:', todosEstabelecimentos);

    const getStatusBadge = (ativo) => {
        return ativo ? (
            <span className={styles.badgeAtivo}>Ativo</span>
        ) : (
            <span className={styles.badgeInativo}>Inativo</span>
        );
    };

    return (
        <div className={styles.secaoPrincipal}>
            <SideBarMaster />
            <div className={styles.containerDashboard}>
               <HeaderMaster />

                <div className={styles.contentDashboard}>
                    <div className={styles.tituloSecao}>
                        <div>
                            <h2>Gestão de Estabelecimentos</h2>
                        </div>
                    </div>

                    <div className={styles.filtersContainer}>
                        <div className={styles.searchBar}>
                            <MdSearch className={styles.searchIcon} />
                            <input
                                type="text"
                                placeholder="Pesquisar por nome, universidade ou administrador..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className={styles.searchInput}
                            />
                        </div>

                        <div className={styles.statusFilter}>
                            <button
                                className={filterStatus === 'todos' ? styles.filterBtnActive : styles.filterBtn}
                                onClick={() => setFilterStatus('todos')}
                            >
                                Todos
                            </button>
                            <button
                                className={filterStatus === 'ativo' ? styles.filterBtnActive : styles.filterBtn}
                                onClick={() => setFilterStatus('ativo')}
                            >
                                Ativos
                            </button>
                            <button
                                className={filterStatus === 'inativo' ? styles.filterBtnActive : styles.filterBtn}
                                onClick={() => setFilterStatus('inativo')}
                            >
                                Inativos
                            </button>
                        </div>
                    </div>

                    <div className={styles.statsCards}>
                        <div className={styles.statCard}>
                            <h3>Total de Estabelecimentos</h3>
                            <p className={styles.statNumber}>{todosEstabelecimentos.length}</p>
                        </div>
                        <div className={styles.statCard}>
                            <h3>Ativos</h3>
                            <p className={styles.statNumber} style={{ color: 'var(--sh-live)' }}>
                                {todosEstabelecimentos.filter(e => e.ativo).length}
                            </p>
                        </div>
                        <div className={styles.statCard}>
                            <h3>Inativos</h3>
                            <p className={styles.statNumber} style={{ color: 'var(--sh-off)' }}>
                                {todosEstabelecimentos.filter(e => !e.ativo).length}
                            </p>
                        </div>
                    </div>

                    <div className={styles.tableContainer}>
                        {loading ? (
                            <p className={styles.loading}>Carregando...</p>
                        ) : (
                            <>
                                {/* Tabela para desktop */}
                                <table className={styles.table}>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Estabelecimento</th>
                                            <th>Universidade</th>
                                            <th>Administrador</th>
                                            <th>Contato</th>
                                            <th>Status</th>
                                            <th>Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredEstabelecimentos.length > 0 ? (
                                            filteredEstabelecimentos.map(est => (
                                                <tr key={est.id}>
                                                    <td>{est.id}</td>
                                                    <td className={styles.nomeEstabelecimento}>
                                                        <MdStore className={styles.iconTable} />
                                                        <div>
                                                            <div className={styles.nomeLanchonete}>{est.nome_lanchonete}</div>
                                                            {est.endereco && (
                                                                <div className={styles.endereco}>
                                                                    <MdLocationOn /> {est.endereco}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td>{est.nome_universidade || 'N/A'}</td>
                                                    <td>{est.nome_admin || 'N/A'}</td>
                                                    <td>
                                                        {est.telefone && <div>{est.telefone}</div>}
                                                        {est.email && <div className={styles.email}>{est.email}</div>}
                                                    </td>
                                                    <td>{getStatusBadge(est.ativo)}</td>
                                                    <td>
                                                        <div className={styles.actionButtons}>
                                                            <button
                                                                className={styles.btnToggleOff}
                                                                onClick={() => navigate(`/speedhub/estabelecimento/${est.id}`)}
                                                                title="Gerenciar"
                                                            >
                                                                <MdSettings />
                                                            </button>
                                                            <button
                                                                className={est.ativo ? styles.btnToggleOn : styles.btnToggleOff}
                                                                onClick={() => toggleStatus(est.id, est.ativo)}
                                                                title={est.ativo ? 'Desativar' : 'Ativar'}
                                                            >
                                                                {est.ativo ? <MdToggleOn /> : <MdToggleOff />}
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="7" className={styles.noData}>
                                                    Nenhum estabelecimento encontrado
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                {/* Cards para mobile */}
                                <div className={styles.cardsContainer}>
                                    {filteredEstabelecimentos.length > 0 ? (
                                        filteredEstabelecimentos.map(est => (
                                            <div key={est.id} className={styles.card}>
                                                <div className={styles.cardHeader}>
                                                    <div className={styles.cardTitle}>
                                                        <MdStore className={styles.cardIcon} />
                                                        <h3>{est.nome_lanchonete}</h3>
                                                    </div>
                                                    {getStatusBadge(est.ativo)}
                                                </div>

                                                <div className={styles.cardBody}>
                                                    {est.endereco && (
                                                        <div className={styles.cardRow}>
                                                            <MdLocationOn className={styles.cardRowIcon} />
                                                            <span>{est.endereco}</span>
                                                        </div>
                                                    )}

                                                    <div className={styles.cardRow}>
                                                        <strong>ID:</strong>
                                                        <span>{est.id}</span>
                                                    </div>

                                                    <div className={styles.cardRow}>
                                                        <strong>Universidade:</strong>
                                                        <span>{est.nome_universidade || 'N/A'}</span>
                                                    </div>

                                                    <div className={styles.cardRow}>
                                                        <strong>Administrador:</strong>
                                                        <span>{est.nome_admin || 'N/A'}</span>
                                                    </div>

                                                    {est.telefone && (
                                                        <div className={styles.cardRow}>
                                                            <strong>Telefone:</strong>
                                                            <span>{est.telefone}</span>
                                                        </div>
                                                    )}

                                                    {est.email && (
                                                        <div className={styles.cardRow}>
                                                            <strong>Email:</strong>
                                                            <span className={styles.email}>{est.email}</span>
                                                        </div>
                                                    )}
                                                </div>

                                                <div className={styles.cardFooter}>
                                                    <button
                                                        className={styles.btnToggleOff}
                                                        onClick={() => navigate(`/speedhub/estabelecimento/${est.id}`)}
                                                    >
                                                        <MdSettings />
                                                        <span>Gerenciar</span>
                                                    </button>
                                                    <button
                                                        className={est.ativo ? styles.btnToggleOn : styles.btnToggleOff}
                                                        onClick={() => toggleStatus(est.id, est.ativo)}
                                                    >
                                                        {est.ativo ? <MdToggleOn /> : <MdToggleOff />}
                                                        <span>{est.ativo ? 'Desativar' : 'Ativar'}</span>
                                                    </button>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p className={styles.noData}>Nenhum estabelecimento encontrado</p>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <FooterNavigationMaster />
        </div>
    );
}

export default EstabelecimentosMaster;
